var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 48H76","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Minus.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
